import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT, COLORS } from '../../../styles/theme'

export const NavBar = styled.div`
  position: fixed;
  bottom: ${SPACING.xl};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.full};
  padding: ${SPACING.xs} ${SPACING.sm};
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.06);
  z-index: 100;

  [data-theme='dark'] & {
    box-shadow:
      0 4px 12px rgba(0, 0, 0, 0.4),
      0 1px 3px rgba(0, 0, 0, 0.3);
  }

  @media print {
    display: none;
  }
`

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${BORDER_RADIUS.full};
  border: none;
  background: transparent;
  color: var(--color-text-primary);
  cursor: pointer;
  transition: background 120ms ease;

  &:hover:not(:disabled) {
    background: ${COLORS.primary}14;
    color: ${COLORS.primary};
  }

  &:disabled {
    color: var(--color-text-secondary);
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const NavLabel = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  padding: 0 ${SPACING.md};
  min-width: 90px;
  text-align: center;
  user-select: none;
`

export const ResponseHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
  margin-bottom: ${SPACING.xl};
`

export const ResponseTitle = styled.div`
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const ScrollPad = styled.div`
  height: 80px;
`
